export const cardPaymentCodes = ["54", "55"];
export const paymentFinancialAccountCodes = ["30"];
export const paymentMandateCodes = ["49"];
export const reportTypes = {
  DOCUMENT_REPORT: "DOCUMENT_REPORT",
  VAT_REPORT: "VAT_REPORT",
};

export const DocumentSource = {
  PEPPOL: "PEPPOL",
  API: "API",
};

export const B2C_ELECTRONIC_ADDRESS = "9999999999";
